export { default as DoubleOptInDialog } from './DoubleOptInDialog';
